import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		user-select: none;
		pointer-events: none;
	}
`;

export { StyledContainer };
